<form class="d-flex flex-column" [formGroup]="formGroup">
  <div class="contact-grid">
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'email'" i18n>Email Address</label>
      <app-email-input
        formControlName="email"
        controlId="email"
        [error]="formGroup?.controls?.email?.invalid && formSubmitted" />
      <app-form-error
        *ngIf="formSubmitted && formGroup?.controls?.email?.invalid"
        [errors]="formGroup?.controls?.email?.errors" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'phoneNumber'" i18n>Phone Number</label>
      <app-phone-country-code
        controlId="phoneNumber"
        [countryCodes]="countryCodes$ | async"
        [formGroup]="formGroup"
        [error]="formGroup?.controls?.phoneNumber?.invalid && formSubmitted"
        [phoneNumberControlName]="'phoneNumber'"
        [countryCodeControlName]="'phoneNumberCountryCode'" />
      <app-form-error
        *ngIf="formSubmitted && formGroup?.controls?.phoneNumber?.invalid"
        [errors]="formGroup?.controls?.phoneNumber?.errors" />
    </div>
  </div>

  <ng-container *ngIf="showUseMemberAddressCheckbox$ | async">
    <hr class="section-divider" />
    <div class="checkbox-container">
      <app-checkbox-input formControlName="useMemberAddress" controlId="useMemberAddress" />
      <app-form-option-label labelFor="useMemberAddress">{{ useAddressCheckboxLabel$ | async }}</app-form-option-label>
    </div>
  </ng-container>

  <app-international-address-form-grid
    class="address-grid"
    controlIdPrefix="spouseAddress"
    [form]="formGroup.controls.address"
    [formSubmitted]="formSubmitted" />
</form>
